import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, TEXT_ALIGNMENT_OPTIONS, TextAlignmentOptions } from '#const';
import { getIconUrl } from '#utils';

const Button = dynamic(() => import('./Button'));

Builder.registerComponent(Button, {
	name: 'Button',
	inputs: [
		{
			name: 'copy',
			required: true,
			friendlyName: 'Button Text',
			type: 'string',
			defaultValue: 'See if I Qualify',
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: false,
			helperText: `If true, will use colors set on page for styling;
				if false, use the controls below`,
		},

		{
			name: 'color',
			friendlyName: 'Button Color',
			type: 'color',
			defaultValue: 'rgba(17, 186, 0, 1)',
			helperText: 'Be sure to select a color dark enough for the white text to legible.',
			// eslint-disable-next-line object-shorthand
			showIf: function (options) {
				return options.get('usePageColors') !== true;
			},
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: '#FFF',
			helperText: 'Be sure to select a color light enough for the text to have contrast.',
		},
		{
			name: 'arrow',
			friendlyName: 'Show Arrow Icon',
			type: 'boolean',
			defaultValue: true,
		},
		{
			name: 'hover',
			friendlyName: 'Hover Color',
			type: 'color',
			helperText: `Optional color for when user hovers button. 
				Be sure to select a color dark enough for the text to legible.`,
		},
		{
			name: 'buttonAlignment',
			friendlyName: 'Button Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional alignment for the button.',
		},
		{
			name: 'scrollTo',
			friendlyName: 'Scroll within page',
			type: 'boolean',
			defaultValue: false,
			helperText: `Choose true if this button will scroll the user to an
				ID on the page. The href should be an id like "#form"`,
		},
		{
			name: 'href',
			friendlyName: 'Link',
			type: 'string',
			defaultValue: '#form',
			helperText: `Full URL that the button should redirect to. If button should scroll
				user to an in-page section this value should be the section ID. Ex: "#form"`,
		},
		{
			name: 'wideButton',
			friendlyName: 'Wide Button',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Add extra horizontal padding to the button',
		},
	],
	image: getIconUrl(Icon.BUTTON),
});
